export const ENTITY_TYPE = {
  Folder: "folder",
  Resource: "resource",
};
